/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/* eslint-env browser */

import ErrorName from '../error/error-name';

// TODO: Mít jednotný fetch, předávat timeout v opts objektu,
// umožnit zrušení timeoutu (i když to je asi chtěné vždy).

/**
 * Metoda vrátí textový obsah těla.
 * Pro každý status kód mimo rozsah 200 - 299 vyhodí výjimku.
 * @param {string} input Fetch má normálně na vstupu string | URL | Request,
 * ale zde kvůli jednoduchosti pouze string.
 * @param {RequestInit} [init]
 * @param {number} [timeoutInMs]
 * @returns {Promise<string>} Vrátí contentSettings jako text, pokud je dostupný.
 * @throws {RangeError} Pokud je status code jiný než z rozsahu 200 - 299.
 */
export async function fetchTextThrowNotOk(input, init, timeoutInMs) {
  const response = await fetchWithTimeout(input, init, timeoutInMs);
  if (!response.ok) {
    throw new RangeError(
      `Invalid HTTP status "${response.status}" for ${
        init?.method ?? 'GET'
      } ${input}.`
    );
  }
  return response.text();
}

/**
 * Obohacuje záladní funkci fetch o možnost nastavení timeoutu
 * pro přerušení stahování, pokud v daném čase nebyl request dokončen.
 * @param {string | URL | Request} input
 * @param {RequestInit} [init]
 * @param {number} [timeoutInMs]
 * @returns {Promise<Response>}
 */
export async function fetchWithTimeout(input, init, timeoutInMs = 30000) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutInMs);

  try {
    const response = await fetch(input, {
      ...init,
      signal: controller.signal
    });
    clearTimeout(timeoutId);
    return response;
  } catch (err) {
    if (/** @type {Error} */ (err).name === 'AbortError') {
      const error = new Error('The fetch has timed out.');
      error.name = ErrorName.TimeoutError;
      throw error;
    }
    throw err;
  }
}
